import { I18n } from '@calendly/i18n';
import { BodyText } from '@calendly/ui/components/typography';
import { colorTextSecondary } from '@calendly/ui/theme';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useSelector } from 'react-redux';
import { isOnTrialStageSelector } from 'features/billing';
const subheaderCss = "s1dm4432";
const Subheader = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(subheaderCss, props.className)} />;
});
export const AvailableSeatsMessage = ({
  availableSeats
}) => {
  const isTrial = useSelector(isOnTrialStageSelector);
  if (isTrial) {
    return <Subheader>
        <BodyText size="medium" color={colorTextSecondary}>
          {I18n.t('publisher.add_users_modal.available_seats.trial')}
        </BodyText>
      </Subheader>;
  }
  return <Subheader>
      <BodyText size="medium" color={colorTextSecondary}>
        {I18n.t('publisher.add_users_modal.available_seats.paid', {
        seat_count: availableSeats
      })}
      </BodyText>
    </Subheader>;
};

require("./available_seats_message.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./available_seats_message.js");